import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { tap } from 'rxjs/operators';

export const canAuthenticated: CanActivateFn = () => {
  const router = inject(Router);
  const nbAuthService = inject(NbAuthService);
  return nbAuthService.isAuthenticatedOrRefresh().pipe(
    tap((authenticated) => {
      if (!authenticated) {
        router
          .navigate(['auth/login'])
          .catch((error: unknown) => console.error('Redirect to the login page failed', error));
      }
    }),
  );
};
